import { ProductVatConfigManagement } from '@/pages/product-vat-config/ProductVatConfigManagement';
import { domesticVatConfigScreen } from '@/pages/product-vat-config/productVatConfigScreenConfig';

const DomesticVatConfigManagement = () => {
  return <ProductVatConfigManagement screenConfig={domesticVatConfigScreen} />;
};

export default DomesticVatConfigManagement;
